export function buildConfig(config) {
    const schema = [];
    schema.push(...config.schema);
    if (config.plugins) {
        config.plugins.forEach((plugin) => {
            schema.push(...plugin.schema);
        });
    }
    return {
        schema,
    };
}
